import "../settings";
import "../utils/fetch_or_go_offline";
export class Word {
    constructor(json_obj) {
        for (const key in json_obj) {
            this[key] = json_obj[key];
        }
    }
}
